import { render } from "./JsonConfig.vue?vue&type=template&id=8f23c776"
import script from "./JsonConfig.vue?vue&type=script&lang=js"
export * from "./JsonConfig.vue?vue&type=script&lang=js"

import exportComponent from "/Users/reinlabares/Labs/imwt/crawl-ui/crawl-interface/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__